import React, { useState } from 'react';
import {Form} from 'react-bootstrap';
import CreatableSelect from 'react-select/creatable';
import {databaseNamespaceOptions, IOptionType} from "../../types/common";
import {MultiValue} from "react-select";
import {FilterPopover} from "../../components";

interface IMatchedPairsFilterProps {
    manufacturers: IOptionType[];
    selectedManufacturerOptions: IOptionType[];
    selectedNamespace: IOptionType;
    onchangeNamespace: (value: IOptionType) => void;
    noItems: number;
    onChangeManufacturers: (items: MultiValue<IOptionType>) => void;
    onChangeNoItems: (value: number) => void;
    t: (key: string) => string;
    handleApplyFilter: (event: React.FormEvent) => void;
    isLoading: boolean;
}

export const MatchedPairsFilter: React.FC<IMatchedPairsFilterProps> = ({
                                                                           manufacturers,
                                                                           selectedManufacturerOptions,
                                                                           selectedNamespace,
                                                                           onchangeNamespace,
                                                                           noItems,
                                                                           onChangeManufacturers,
                                                                           onChangeNoItems,
                                                                           isLoading,
                                                                           handleApplyFilter,
                                                                           t,
                                                                       }) => {                                                     
    return (
        <FilterPopover
            id="matched-pairs-filter"
            title={t("OnlyMatchToOEM.FilterTitle")}
            isLoading={isLoading}
            onApplyFilter={handleApplyFilter}
            t={t}
        >
            <Form onSubmit={handleApplyFilter}>
            <Form.Group className="mb-3">
                <Form.Label>{t("Filter.imageType")}:</Form.Label>
                <CreatableSelect
                    className="card border-0"
                    closeMenuOnSelect={true}
                    options={databaseNamespaceOptions}
                    onChange={(selectedOption) => onchangeNamespace(selectedOption as IOptionType)}
                    value={selectedNamespace}
                    placeholder={t("Filter.imageType")}
                />
            </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>{t("Filter.manufacturer")}:</Form.Label>
                    <CreatableSelect
                        className="card border-0"
                        closeMenuOnSelect={false}
                        isMulti
                        isDisabled={isLoading}
                        options={manufacturers}
                        value={selectedManufacturerOptions}
                        placeholder={t("Filter.manufacturer")}
                        isSearchable
                        onChange={onChangeManufacturers}
                    />
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>{t("Config.top_k")}: {noItems}</Form.Label>
                    <Form.Range
                        min="1"
                        max="1000"
                        step="1"
                        disabled={isLoading}
                        value={noItems}
                        onChange={(e) => onChangeNoItems(parseFloat(e.target.value))}
                    />
                </Form.Group>
            </Form>
        </FilterPopover>
    );
};
